import React from 'react'
import { PRECEDENTS_CONTENT } from 'constants/controllers'
import getUrl from 'front-end-core/core/url'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import TealToolTip from 'components/TealToolTip'
import IconButton from '@material-ui/core/IconButton'
import CloudUpload from '@material-ui/icons/CloudUpload'

const SectionHeader = ({ sectionTitle, sectionId, isAdmin, aol, view, expandedSection }) => (
  <div className='bb-thick b--precedents-blue'>
    <Grid container justify='space-between' className='pt7 pb6'>
      <Grid item className='b f3 pl6'>
        {sectionTitle}
      </Grid>
      <Grid item className='pr5'>
        <Hidden xsDown>
          <div>
            {isAdmin && <UploadLink aol={aol} view={view} sectionId={sectionId} expandedSection={expandedSection} />}
          </div>
        </Hidden>
      </Grid>
    </Grid>
  </div>
)

const UploadLink = ({ aol, view, sectionId, expandedSection: expanded }) => {
  const theme = createMuiTheme({ palette: { primary: { main: '#004b7a' } } })
  const url = getUrl(PRECEDENTS_CONTENT, { aol, view, sectionId, precedentId: 'new', expanded })

  return (
    <a href={url}>
      <MuiThemeProvider theme={theme}>
        <TealToolTip title='Upload new precedent' placement='top-end'>
          <IconButton style={{ width: '2.5rem', height: '2.5rem' }} color='primary'>
            <CloudUpload />
          </IconButton>
        </TealToolTip>
      </MuiThemeProvider>
    </a>
  )
}

export default SectionHeader
